import { useMemo } from 'react';

import { createEditor } from 'slate';
import { withReact } from 'slate-react';

import { withQueryNodes } from '../normalizer/normalizer';
import { withNodeSpacing } from '../plugins';
import { CustomEditor } from '../types';

export const useSlateEditor = () => {
  return useMemo(
    () => withNodeSpacing(withQueryNodes(withReact(createEditor()))) as CustomEditor,
    [],
  );
};
